/**
 * @generated SignedSource<<6f185af33523a1eeee56cc34e6092ad9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UserPreferencesAsyncTaskQuery$variables = {
  taskId: any;
};
export type UserPreferencesAsyncTaskQuery$data = {
  readonly viewer: {
    readonly asyncTask: {
      readonly info: any;
      readonly state: string;
      readonly taskId: any;
    } | null;
  };
};
export type UserPreferencesAsyncTaskQuery = {
  response: UserPreferencesAsyncTaskQuery$data;
  variables: UserPreferencesAsyncTaskQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskId"
  }
],
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "taskId",
      "variableName": "taskId"
    }
  ],
  "concreteType": "AsyncTask",
  "kind": "LinkedField",
  "name": "asyncTask",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taskId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "info",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserPreferencesAsyncTaskQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserPreferencesAsyncTaskQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6b02ef97fe9e70a68e206e7faf0dda0e",
    "id": null,
    "metadata": {},
    "name": "UserPreferencesAsyncTaskQuery",
    "operationKind": "query",
    "text": "query UserPreferencesAsyncTaskQuery(\n  $taskId: JSON!\n) {\n  viewer {\n    asyncTask(taskId: $taskId) {\n      taskId\n      state\n      info\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "44c0b26c685b9d94d014c5d5a1727bbd";

export default node;
